import { render, staticRenderFns } from "./Html-data.vue?vue&type=template&id=dbd32438"
import script from "./Html-data.vue?vue&type=script&lang=js"
export * from "./Html-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports